export default "__VITE_ASSET__C7N4t3vD__"